import { GridCustomCellProps } from "@progress/kendo-react-grid";

const formatNumber = (value: any): string => {
  if (value === null || value === undefined || value === "") return "0.00";
  const num = parseFloat(value);
  return isNaN(num) ? "0.00" : num.toFixed(2);
};

interface Props extends GridCustomCellProps {
  field: string;
}

export const FormattedNumberCell = ({ dataItem, field }: Props) => {
  return (
    <td
      className="k-table-td"
      style={{
        borderBottom: "1px solid var(--kendo-color-border)",
        borderLeft: "none",
        borderRight: "none",
        fontFamily: "Roboto",
        textAlign: "center",
      }}
    >
      {formatNumber(dataItem[field])}
    </td>
  );
};
